/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

// 메뉴 기반 기본 리다이렉트 컴포넌트 (절대경로 사용)
const DefaultRedirect: FC = () => {
  const {menu} = useAuth()
  if (menu && menu.length > 0) {
    // pages가 있는 첫 번째 메뉴 찾기 (대시보드 등 빈 메뉴 스킵)
    for (const m of menu) {
      if (m.pages && m.pages.length > 0) {
        return <Navigate to={m.pages[0].menuUrl} replace />
      }
    }
    // pages가 있는 메뉴가 없으면 첫 메뉴 URL 직접 사용
    return <Navigate to={menu[0].menuUrl} replace />
  }
  return <Navigate to='/auth' replace />
}

const AppRoutes: FC = () => {
  const {currentUser, auth} = useAuth()
  // auth.apiToken은 localStorage에서 즉시 복원되므로,
  // 새로고침 시 currentUser API 응답 전에도 인증 라우트 유지
  const isAuthenticated = !!(currentUser || auth?.apiToken)

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {isAuthenticated ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<DefaultRedirect />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
